export default __webpack_public_path__ + "static/media/3.ae14c616.jpg";